import { useTheme as useNextTheme } from "next-themes";
import { useEffect, useState } from "react";
import { type Theme } from "~/constants";

export function useTheme() {
  const { theme, setTheme, resolvedTheme, systemTheme } = useNextTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return {
    theme: theme as Theme | undefined,
    setTheme: setTheme as (theme: Theme) => void,
    resolvedTheme: resolvedTheme as "light" | "dark" | undefined,
    systemTheme: systemTheme as "light" | "dark" | undefined,
    mounted,
  };
}
